import { Modal } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ModalHeader } from "datastake-daf/dist/components";
import {
  streamOptions,
  historyOptions,
  deliveryOptions,
  licensingOptions,
  accessbilityOptions,
  discoverabilityOptions,
} from "./config";
import { Style } from "../../../../components/dashboards/components/project-visualisation";
import Footer from "../../../../components/dashboards/components/project-visualisation/components/Footer";
import Select from "../../../../components/dashboards/components/project-visualisation/components/Select";

export default function Settings({
  defaultData = {},
  settingsVisible,
  setSettingsVisible,
  supportText,
  title = 'Disclosure Settings',
  onFinish = () => { },
}) {
  const { t } = useTranslation();
  const [formValue, setFormValue] = useState(defaultData);

  const onChange = (key, value) =>
    setFormValue((prev) => ({ ...prev, [key]: value }));

  const onSubmit = () => {
    setSettingsVisible(false);
    onFinish(formValue);
  }

  const onClose = () => {
    setSettingsVisible(false);
    setFormValue({ delivery: 'custom' });
  }

  return (
    <Modal
      open={settingsVisible}
      onCancel={() => setSettingsVisible(false)}
      footer={null}
      title={(
        <ModalHeader
          title={t(title)}
          supportText={t(supportText)}
          tooltip={{
            title: t('Disclosure Settings'),
            content: t('This feature enables you to set specific rules with regards to how other parties may find, access or use your available information. Of course you may decide to keep it entirely private.'),
          }}
        />
      )}
      width={400}
      className="custom-modal"
    >

      <Style>
        <div className="form-group">
          <Select
            options={discoverabilityOptions.map((o) => ({ ...o, label: t(o.label) }))}
            value={formValue.discoverability}
            label={t('Discoverability')}
            onChange={(v) => {
              onChange('discoverability', v);
            }}
            tooltip={{
              title: t('Discoverability'),
              content: t('Rules for your information to appear in searches.')
            }}
          />

          <Select
            options={accessbilityOptions.map((o) => ({ ...o, label: t(o.label) }))}
            value={formValue.accessibility}
            label={t('Accessibility')}
            onChange={(v) => {
              onChange('accessibility', v);
            }}
            tooltip={{
              title: t('Accessibility'),
              content: t('Conditions for access to your information by other parties.')
            }}
          />

          <Select
            options={historyOptions.map((o) => ({ ...o, label: t(o.label) }))}
            value={formValue.history}
            label={t('History')}
            onChange={(v) => {
              onChange('history', v);
            }}
            tooltip={{
              title: t('History'),
              content: t('Versions of your information to be shared.')
            }}
          />

          <Select
            options={streamOptions.map((o) => ({ ...o, label: t(o.label) }))}
            value={formValue.stream}
            label={t('Stream')}
            onChange={(v) => {
              onChange('stream', v);
            }}
            tooltip={{
              title: t('Stream'),
              content: t('One-off sharing or continuous updates.')
            }}
          />

          <Select
            disabled
            options={deliveryOptions.map((o) => ({ ...o, label: t(o.label) }))}
            value={formValue.delivery}
            label={t('Delivery')}
            onChange={(v) => {
              onChange('delivery', v);
            }}
            tooltip={{
              title: t('Delivery'),
              content: t('Location where information may be consulted (e.g. inside a specific application)')
            }}
          />

          <Select
            options={licensingOptions.map((o) => ({ ...o, label: t(o.label) }))}
            value={formValue.licensing}
            label={t('Licensing')}
            onChange={(v) => {
              onChange('licensing', v);
            }}
            tooltip={{
              title: t('Licensing'),
              content: t('Rules governing how the information you share may be used by your partners.')
            }}
          />
        </div>

        <Footer
          onClose={onClose}
          onSubmit={onSubmit}
          loading={false}
          t={t}
          disabledFooter={false}
        />
      </Style>
    </Modal>
  )
}
